import { GridUtils } from '@/shared/util/grid-utils'

export const WASTE_TASK = {
    TO_BE_DISCARDED: {
        code: 'TO_BE_DISCARDED',
        url: 'toBeDiscarded',
        showDiscardButton: true,
        showUndoDiscardButton: false
    },
    PRESERVED: {
        code: 'PRESERVED',
        url: 'preserved',
        showDiscardButton: false,
        showUndoDiscardButton: false
    },
    TO_BE_UNARCHIVED_FOR_DISPOSAL: {
        code: 'TO_BE_UNARCHIVED_FOR_DISPOSAL',
        url: 'toBeUnarchivedToDiscard',
        showDiscardButton: false,
        showUndoDiscardButton: false
    },
    DISCARDED: {
        code: 'DISCARDED',
        url: 'discarded',
        showDiscardButton: false,
        showUndoDiscardButton: true
    }
}

export default {
    sideBarName: 'WasteSideBar',
    expanded: [
        {
            id: 'pendingSection',
            label: 'waste.sidebar.section',
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'toBeDiscarded',
                    label: 'waste.sidebar.toBeDiscarded',
                    hasChildren: false,
                    icon: ['fal', 'trash'],
                    filterModel: {},
                    uicomponent: 'uicomponent.waste.filter.toBeDiscarded',
                    task: WASTE_TASK.TO_BE_DISCARDED
                },
                {
                    id: 'toBeUnarchivedForDisposal',
                    label: 'waste.sidebar.toBeUnarchivedForDisposal',
                    hasChildren: false,
                    icon: ['fal', 'inbox-out'],
                    filterModel: {},
                    uicomponent: 'uicomponent.waste.filter.pendingToBeUnarchived',
                    task: WASTE_TASK.TO_BE_UNARCHIVED_FOR_DISPOSAL
                }
            ]
        },
        {
            id: 'preservedSection',
            label: 'waste.sidebar.preserved',
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'preserved',
                    label: 'waste.sidebar.preserved',
                    hasChildren: false,
                    icon: ['fal', 'recycle'],
                    filterModel: {},
                    uicomponent: 'uicomponent.waste.filter.preserved',
                    task: WASTE_TASK.PRESERVED
                }
            ]
        },
        {
            id: 'discardedSection',
            label: 'waste.sidebar.disposedSamples',
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'wasteToday',
                    label: 'waste.sidebar.today',
                    icon: ['fal', 'calendar-day'],
                    filterModel: {
                        samDisposalDate: GridUtils.getTodayDateFilterModel()
                    },
                    uicomponent: 'uicomponent.waste.filter.discarded',
                    task: WASTE_TASK.DISCARDED
                },
                {
                    id: 'wasteLastWeek',
                    label: 'waste.sidebar.lastWeek',
                    icon: ['fal', 'calendar-week'],
                    filterModel: {
                        samDisposalDate: GridUtils.getThisWeekDateFilterModel()
                    },
                    uicomponent: 'uicomponent.waste.filter.discarded',
                    task: WASTE_TASK.DISCARDED
                },
                {
                    id: 'wasteLastMonth',
                    label: 'waste.sidebar.lastMonth',
                    icon: ['fal', 'calendar-alt'],
                    filterModel: {
                        samDisposalDate: GridUtils.getThisMonthDateFilterModel()
                    },
                    uicomponent: 'uicomponent.waste.filter.discarded',
                    task: WASTE_TASK.DISCARDED
                }
            ]
        }
    ],
    module: {
        icon: ['fal', 'trash'],
        name: 'waste.sidebar.waste'
    }
}
